export interface PlanFeatureRow {
  name: string;
  free: string | boolean;
  pro: string | boolean;
}

export const PRICING_DISCLAIMER =
  "All prices are in Indian Rupees (INR) and exclusive of applicable taxes (GST).";

export const PRICING_PLANS = {
  free: {
    id: "free",
    name: "Free",
    priceLabel: "₹0",
    periodLabel: "Forever free",
    description: "Core tracking and planning tools to get started.",
    cta: "Get Started Free",
  },
  monthly: {
    id: "monthly",
    name: "Pro Monthly",
    priceLabel: "₹99",
    periodLabel: "per month",
    description: "Full access with flexible monthly billing.",
    cta: "Start Pro Monthly",
  },
  annual: {
    id: "annual",
    name: "Pro Annual",
    priceLabel: "₹949",
    periodLabel: "per year",
    equivalentLabel: "≈ ₹79/month",
    savingsLabel: "Save ~20% vs monthly",
    description: "Best value for committed wealth builders.",
    cta: "Start Pro Annual",
  },
} as const;

export const PLAN_COMPARISON_FEATURES: PlanFeatureRow[] = [
  { name: "Investment & asset tracking", free: "Up to 10 accounts", pro: "Unlimited" },
  { name: "Expense tracking", free: "Basic", pro: "Advanced" },
  { name: "Goal planning", free: true, pro: true },
  { name: "Reports & insights", free: "Limited", pro: "Unlimited" },
  { name: "Family Hub", free: false, pro: "3 members included" },
  { name: "Advanced analytics", free: false, pro: true },
  { name: "Data export", free: false, pro: true },
  { name: "Priority support", free: false, pro: "Annual plan" },
];
